import { Box, useTheme, Button } from "@mui/material";
import FixedSizeDialog from "components/fixedSizeDialog";
import { useState } from "react";
import { useSelector } from "react-redux";
import ReportTable, { RRow, RCell } from "components/Tables/ReportTable";
import { useGetBusinessBranchList } from "api/hooks/business";
import BusinessBranchDetailEditForm from "../forms/businessBranchDetailsEdit";
import {requester} from "api/pesabackend";

export default function BusinessBranchTable({ setIsSuccess }) {
  const theme = useTheme();
  const business_id = useSelector((state) => state.authReducer.business_id);
  const [openEdit, setOpenEdit] = useState(false);

  const [editData, setEditData] = useState("");
  const [clickedItem, setClickedItem] = useState("");
  const { businessBranchList, isLoadingBusinessBranchList, setNewBusinessBranchData} = useGetBusinessBranchList(1, business_id)

  const handleClickEditOpen = async (e) => {
    setClickedItem(e.target.value);
    const response = await requester.get(`/tenants/business_branch/get/${e.target.value}`);
    setEditData(response.data.data);
    setOpenEdit(true);
  };

  const handleClickEditClose = () => {
    setOpenEdit(false);
  };

  return (
    <Box>
      <h4>Business Branch List</h4>

      <Box>
        <ReportTable
          columns={[
            { label: "No.", width: 50 },
            { label: "Branch Name" },
            { label: "Contact" },
            { label: "Location" },
            { label: "Actions", align: "center" },
          ]}
          rows={businessBranchList}
          loading={isLoadingBusinessBranchList}
          emptyMessage="No data found"
          renderRow={(row, index) => (
            <RRow key={row.id} index={index}>
              <RCell>{row.id}</RCell>
              <RCell>{row.branch_name}</RCell>
              <RCell>{row.branch_contact}</RCell>
              <RCell>{row.branch_location}</RCell>
              <RCell align="center">
                <Button
                  value={row.id}
                  size="small"
                  onClick={(e) => handleClickEditOpen(e)}
                >
                  Edit Details
                </Button>

                <FixedSizeDialog
                  dialogHeading="Edit Business Branch Details"
                  open={openEdit}
                  handleClose={handleClickEditClose}
                  negativeResponse="Cancel"
                  maxWidth={"md"}
                  content={
                    <Box
                      p="1rem"
                      borderRadius="0.5rem"
                      backgroundColor={theme.palette.background.alt}
                    >
                      <BusinessBranchDetailEditForm setOpen={setOpenEdit} setNewBusinessBranchData={setNewBusinessBranchData} id={clickedItem} editData={editData} setIsSuccess={setIsSuccess} />
                    </Box>
                  }
                />
              </RCell>
            </RRow>
          )}
        />
      </Box>
    </Box>
  );
}
